// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1385":"77b369ec","2589":"d6fdf0fb","3532":"887972a4","4226":"d8182b59","9103":"b9ea4917"}[chunkId] + ".css";
};